import { useLocation } from "@reach/router";
import { useEffect, useState } from "react";

export const useVerified = () => {
  const [isVerified, setIsVerified] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.search === "?verified=true") {
      setIsVerified(true);
    }
  }, [location.search]);

  let verifiedString = "";
  if (isVerified) {
    verifiedString = "?verified=true";
  }

  return { isVerified, verifiedString };
};
